import { ILibraryEnvironment } from '../registry.types';
import { isBrowser } from '../flags';

export function createEnvironmentLoader({
  loadRuntime,
  loadHotBundle,
  environment,
}: {
  loadRuntime: (params: { url: string }) => Promise<void>;
  loadHotBundle: (params: { url: string }) => Promise<void>;
  environment: ILibraryEnvironment;
}) {
  let isLoaded = false;
  let pending: Promise<any> | null = null;

  return {
    load(): Promise<void> {
      if (pending) {
        return pending;
      }

      pending = Promise.all([
        environment.runtime
          ? loadRuntime({
              url: environment.runtime,
            })
          : null,
        environment.hot && isBrowser
          ? loadHotBundle({
              url: environment.hot,
            })
          : null,
      ]);

      isLoaded = true;

      return pending;
    },
    isLoaded() {
      return isLoaded;
    },
  };
}
